import * as React from 'react';
import Main from "../components/Main";
import ResultsTable from "../components/ResultsTable";
import {
    add_url_param,
    fill_filters_from_url,
    fill_table_from_url, mysql_date,
    parse_url_params,
    remove_url_param,
} from "../Common";
import {useContext, useEffect, useState} from "react";
import API, {HandleError} from "../API";
import {useSnackbar} from "notistack";
import AppContext from "../AppContext";
import FiltersStudent from "../components/FiltersStudent";
import StudentDelete from "../components/StudentDelete";
import StudentPopup from "../components/StudentPopup";
import StudentBulk from "../components/StudentBulk";
import StudentMail from "../components/StudentMail";
import StudentWhatsapp from "../components/StudentWhatsapp";

export default function Students() {
    const app = useContext(AppContext);
    const { enqueueSnackbar } = useSnackbar();

    let urlParams = parse_url_params(window.location.href);
    let openItem = isFinite(parseInt(urlParams?.open)) ? parseInt(urlParams?.open) : 0;

    const [popup, setPopup] = useState({
        loading: false,
        open: openItem > 0,
        item: openItem ? { ID: openItem } : null,
        reload: true,
        title: '',
        maxWidth: 'lg',
        fullWidth: true
    });
    const [mailPopup, setMailPopup] = useState({
        loading: false,
        open: false,
        item: null,
        reload: true,
        title: '',
        maxWidth: 'sm',
        fullWidth: true
    });
    const [whatsappPopup, setWhatsappPopup] = useState({
        loading: false,
        open: false,
        item: null,
        reload: true,
        title: '',
        maxWidth: 'sm',
        fullWidth: true
    });
    const [notesPopup, setNotesPopup] = useState({
        loading: false,
        open: false,
        item: null,
        reload: true,
        title: '',
        maxWidth: 'sm',
        fullWidth: true
    });
    const [deletePopup, setDeletePopup] = useState({
        loading: false,
        open: false,
        items: [],
        title: '',
        maxWidth: 'sm',
        fullWidth: true
    });
    const [bulkPopup, setBulkPopup] = useState({
        loading: false,
        open: false,
        items: [],
        title: '',
        maxWidth: 'md',
        fullWidth: true
    });

    useEffect(() => {
        if(popup.open) {
            let url = add_url_param(window.location.href, 'open', popup?.item?.ID);
            window.history.replaceState(null, null, url);
        }
        else {
            let url = remove_url_param(window.location.href, 'open');
            if(url !== window.location.href)
                window.history.replaceState(null, null, url);
        }
    }, [popup.open, popup?.item?.ID])

    const initTable = {
        title: 'Students',
        get_url: '/students',
        results: [],
        results_count: 0,
        total_pages: 0,
        total_count: 0,
        loading: false,
        selected: [],
        per_page: 10,
        page: 1,
        order: 'desc',
        order_by: 'createdAt',
        columns: {
            'Name': {
                field: 'full_name',
                sortable: true,
                visible: true
            },
            'Company': {
                field: 'company',
                sortable: true,
                visible: false,
                required: true
            },
            'Course': {
                field: 'courses',
                sortable: false,
                visible: true
            },
            'E-mail': {
                field: 'email',
                sortable: true,
                visible: true
            },
            'Status': {
                field: 'status',
                sortable: true,
                visible: true
            },
            'Payment': {
                field: 'payment_info',
                sortable: true,
                visible: true
            },
            'CBR Info': {
                field: 'cbr_info',
                sortable: false,
                visible: false,
                required: true,
            },
            'Created At': {
                field: 'createdAt',
                sortable: true,
                visible: true
            }
        }
    };

    const initFilters = {
        search: '',
        search_by: '',
        product: '',
        product_multiple: 0,
        search_by_options: ['full_name', 'email', 'cbr_number', 'company'],
        status: '',
        course_date: '',
        course_location: '',
        cancelled: '',
        absent: '',
        confirmed: '',
        processed: '',
        result: '',
        is_company: '',
    };

    const resetFilters = {...initFilters}

    const premadeFilters = {
        'Today Confirmed in Amsterdam': {
            confirmed: 'semi',
            course_date: mysql_date(new Date()) + ' - ' + mysql_date(new Date()),
            course_location: 'Amsterdam'
        }
    }

    fill_table_from_url(initTable);
    fill_filters_from_url(initFilters, ['processed'])

    const [table, setTable] = useState(initTable);
    const [filters, setFilters] = useState(initFilters);

    const onMainRowClick = (item) => {
        setPopup({...popup,
            open: true,
            item: item,
            title: `Loading edit...`,
            loading: true
        })
    }

    const onDeleteClick = () => {
        if(table.selected.length) {
            const items = table.results.filter((val, idx) => {
                if(table.selected.indexOf(val.ID) !== -1)
                    return val;

                return false;
            })
            setDeletePopup({
                ...deletePopup,
                open: true,
                items: items,
                title: 'Delete Students'
            })
        }
    }
    const onBulkClick = () => {
        if(table.selected.length) {
            const items = table.results.filter((val, idx) => {
                if(table.selected.indexOf(val.ID) !== -1)
                    return val;

                return false;
            })
            setBulkPopup({
                ...bulkPopup,
                open: true,
                items: items,
                title: 'Update Students'
            })
        }
    }

    const refreshTable = async () => {
        setTable({...table, results: [], selected: [], results_count: table.results.length, loading: true})
        try {
            let params = {
                order: encodeURIComponent(table.order),
                order_by: encodeURIComponent(table.order_by),
                per_page: table.per_page,
                page: table.page
            };
            let fields = ['ID', 'lock_user', 'admin_notes'];

            for(let field_name in table.columns) {
                let col = table.columns[field_name];
                if(col?.visible || col?.required) {
                    if(col.field === 'cbr_info') {
                        fields.push('cbr_account');
                        fields.push('cbr_number');
                        fields.push('cbr_time');
                        fields.push('cbr_code');
                        fields.push('cbr_status');
                    }
                    else if(col.field === 'payment_info') {
                        fields.push('payment');
                        fields.push('paid_amount');
                        fields.push('paid_cash_amount');
                        fields.push('unpaid_amount');
                        fields.push('refunded_amount');
                        fields.push('price');
                        fields.push('total_price');
                    }
                    else
                        fields.push(col.field);
                }
            }
            //always-needed fields
            fields.push('confirmed');
            fields.push('cancelled');

            if(fields.length > 1)
                params['fields'] = fields.map((v) => encodeURIComponent(v)).join(',');

            if(Object.keys(filters).length) {
                for(var k in filters) {
                    if(filters[k] !== '' && filters[k] !== null && filters[k] !== undefined)
                        params[k] =  typeof filters[k] === "number" ? filters[k] : encodeURIComponent(filters[k]);
                }
            }

            delete params['search_by_options'];

            let url = '';
            if(Object.keys(params).length) {
                for(let k in params) {
                    url += (url === '' ? '?' : '&') + k + '=' + params[k];
                }
            }

            url = table.get_url + url;
            const res = await API({ method: 'GET', url: url,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })
            if(res.status < 200 || res.status > 299)
                throw res.data;

            setTable({...table,
                selected: [],
                results: res.data.results,
                results_count: res.data.results.length,
                page: res.data.page,
                total_pages: res.data.pages,
                total_count: res.data.count,
                loading: false
            })
        }
        catch(e) {
            setTable({...table,
                results: [],
                selected: [],
                results_count: 0,
                total_pages: 0,
                total_count: 0,
                page: 1,
                loading: false
            })
            HandleError(e, table.title, enqueueSnackbar, app.logout);
        }
    }

    return <Main pageTitle="Students">
        <ResultsTable manager="students" onMainRowClick={onMainRowClick}
                      onBulkClick={onBulkClick}
                      onDeleteClick={app.has_cap('student', 'delete') ? onDeleteClick : null}
                      setTable={setTable} table={table}
                      mailPopup={mailPopup} setMailPopup={setMailPopup}
                      refreshTable={refreshTable} setFilters={setFilters} filters={filters} resetFilters={{...resetFilters}}
                      premadeFilters={premadeFilters}>
            <FiltersStudent />
        </ResultsTable>
        <StudentPopup popup={popup} setPopup={setPopup} table={table} setTable={setTable}
                      notesPopup={notesPopup} setNotesPopup={setNotesPopup}
                      mailPopup={mailPopup} setMailPopup={setMailPopup} whatsappPopup={whatsappPopup} setWhatsappPopup={setWhatsappPopup} />
        <StudentDelete popup={deletePopup} setPopup={setDeletePopup} table={table} setTable={setTable} />
        <StudentBulk popup={bulkPopup} setPopup={setBulkPopup} table={table} setTable={setTable} />
        <StudentMail popup={mailPopup} setPopup={setMailPopup} />
        <StudentWhatsapp popup={whatsappPopup} setPopup={setWhatsappPopup} />
    </Main>
}